export default __webpack_public_path__ + "static/media/chevron-arrow-right.4ff123f6.svg";